import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function PaymentGraceBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !user) return null;
  if (user.subscriptionStatus !== "past_due") return null;

  const failedAt = (user as any).paymentFailedAt
    ? new Date((user as any).paymentFailedAt)
    : null;
  if (!failedAt) return null;

  const daysSinceFailure = Math.floor(
    (Date.now() - failedAt.getTime()) / (1000 * 60 * 60 * 24)
  );

  // Only show during grace period (days 0-2)
  if (daysSinceFailure >= 3) return null;

  const isLastDay = daysSinceFailure >= 2;
  const bgColor = isLastDay ? "bg-orange-50 border-orange-200" : "bg-yellow-50 border-yellow-200";
  const textColor = isLastDay ? "text-orange-800" : "text-yellow-800";
  const iconColor = isLastDay ? "text-orange-500" : "text-yellow-500";

  const message = isLastDay
    ? "Your account needs attention soon! Please ask your parent or guardian to check their email."
    : "Hey! Ask your parent or guardian to check their email.";

  return (
    <div className={`${bgColor} border-b px-4 py-3 flex items-center justify-between gap-3`}>
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <AlertTriangle className={`w-4 h-4 shrink-0 ${iconColor}`} />
        <p className={`text-sm ${textColor}`}>{message}</p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className={`shrink-0 ${textColor} hover:opacity-70`}
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
